'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_AppPage$DocumentTemplatesList(pageCursor, kinds) {
  this.z8 = null;
  this.BI = null;
  this.z8 = pageCursor;
  this.BI = kinds;
}
export { $c_Lapp_pages_AppPage$DocumentTemplatesList as $c_Lapp_pages_AppPage$DocumentTemplatesList };
$p = $c_Lapp_pages_AppPage$DocumentTemplatesList.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_pages_AppPage$DocumentTemplatesList;
/** @constructor */
function $h_Lapp_pages_AppPage$DocumentTemplatesList() {
}
export { $h_Lapp_pages_AppPage$DocumentTemplatesList as $h_Lapp_pages_AppPage$DocumentTemplatesList };
$h_Lapp_pages_AppPage$DocumentTemplatesList.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_AppPage$DocumentTemplatesList)) {
    var x = this.z8;
    var x$2 = x$0.z8;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.BI;
      var x$4 = x$0.BI;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "DocumentTemplatesList";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.z8;
  }
  if ((n === 1)) {
    return this.BI;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "pageCursor";
  }
  if ((n === 1)) {
    return "kinds";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_pages_AppPage$DocumentTemplatesList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.k4)));
}
export { $isArrayOf_Lapp_pages_AppPage$DocumentTemplatesList as $isArrayOf_Lapp_pages_AppPage$DocumentTemplatesList };
var $d_Lapp_pages_AppPage$DocumentTemplatesList = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_AppPage$DocumentTemplatesList, "app.pages.AppPage$DocumentTemplatesList", ({
  k4: 1,
  aB: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_pages_AppPage$DocumentTemplatesList as $d_Lapp_pages_AppPage$DocumentTemplatesList };
//# sourceMappingURL=app.pages.-App-Page$-Document-Templates-List.js.map
